<template>
    <v-dialog
      v-model="dialog"
      scrollable
      width="800"
    >
      <v-card>
        <iframe
          v-if="url" 
          :src="url" 
          width="100%"
          height="1200"
        /> 
        <v-btn
          color="bgColor"
          fab
          dark
          small
          absolute
          top
          right
          style="margin-top: 30px;"
          @click="onClose"
          elevation="1"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
</template>
<script>
import utils from '@/services/utils'
export default {
  name: 'ExternalLink',
  props: {
    item: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      required: true,
    },
    bgColor: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    selectedIndex: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    url: null,
    dialog: false,
  }),
  watch: {
    dialog (v) {
      if (!v) this.onClose()
    },
    showDialog (v) {
      this.dialog = v
    },
    locale () {
      this.prepareURL()
    },
    item () {
      this.prepareURL()
    },
    'externalLinkIndex' () {
      this.prepareURL()
    },
  },
  mounted () {
    this.prepareURL()
  },
  methods: {
    prepareURL () {
      this.url = utils.getTranslation(this.item.externalLink, this.locale)
      this.dialog = this.showDialog
    },
  },
}
</script>

